import { useState, useEffect } from 'react';

export const useMediaQuery = () => {
  const [mq, setMq] = useState({
    // ブレイクポイントはtailwindcssのmd:を参考
    isPc: window.matchMedia('screen and (min-width: 768px)').matches,
    isMobile: window.matchMedia('screen and (max-width: 767px)').matches,
    canHover: window.matchMedia('(hover: hover) and (pointer: fine)').matches,
  });

  useEffect(() => {
    const onResize = () => {
      setMq({
        isPc: window.matchMedia('screen and (min-width: 768px)').matches,
        isMobile: window.matchMedia('screen and (max-width: 767px)').matches,
        canHover: window.matchMedia('(hover: hover) and (pointer: fine)')
          .matches,
      });
    };

    window.addEventListener('resize', onResize);
    window.addEventListener('load', onResize);

    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', onResize);
    };
  }, []);

  return mq;
};
